import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer id="footer" className="ml-0 md:ml-64 px-4 md:px-6 py-6 md:py-8 border-t border-white/10">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between space-y-4 md:space-y-0">
        <div className="flex flex-col md:flex-row items-start md:items-center space-y-2 md:space-y-0 md:space-x-6">
          <div className="flex items-center">
            <img 
              src="/logo.svg" 
              alt="Winnomi Logo" 
              className="w-10 h-10 object-contain"
            />
          </div>
          <span className="text-white/50 text-xs md:text-sm">© 2024 Tüm hakları saklıdır</span>
        </div>
        <div className="flex flex-wrap items-center gap-3 md:gap-4">
          <button className="text-white/50 hover:text-white transition-colors text-xs md:text-sm">Gizlilik</button>
          <button className="text-white/50 hover:text-white transition-colors text-xs md:text-sm">Şartlar</button>
          <button className="text-white/50 hover:text-white transition-colors text-xs md:text-sm">Destek</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
